function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React from "react";
import { FieldArray } from "react-final-form-arrays";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Button, Grid, IconButton, Typography } from "@mui/material";
import ButtonTooltip from "../../ButtonTooltip";
// @NOTE: Should not use `children` and `render` prop
export default function ArrayField(_param) {
    var label = _param.label, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_addFieldText = _param.addFieldText, addFieldText = _param_addFieldText === void 0 ? "Add Field" : _param_addFieldText, _param_sortable = _param.sortable, sortable = _param_sortable === void 0 ? false : _param_sortable, fieldRender = _param.fieldRender, fieldInitialValue = _param.fieldInitialValue, rest = _object_without_properties(_param, [
        "label",
        "disabled",
        "addFieldText",
        "sortable",
        "fieldRender",
        "fieldInitialValue"
    ]);
    return /*#__PURE__*/ _jsx(FieldArray, _object_spread_props(_object_spread({}, rest), {
        children: function(param) {
            var fields = param.fields;
            return /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                direction: "column",
                spacing: 1,
                children: [
                    label && /*#__PURE__*/ _jsx(Grid, {
                        item: true,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "body2",
                            color: "textSecondary",
                            children: label
                        })
                    }),
                    /*#__PURE__*/ _jsx(Grid, {
                        item: true,
                        children: /*#__PURE__*/ _jsxs(Grid, {
                            container: true,
                            spacing: 1,
                            direction: "column",
                            children: [
                                fields.map(function(name, i) {
                                    return /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        children: /*#__PURE__*/ _jsxs(Grid, {
                                            container: true,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ _jsx(Grid, {
                                                    item: true,
                                                    xs: 11,
                                                    children: fieldRender({
                                                        name: name,
                                                        i: i,
                                                        values: fields.value
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs(Grid, {
                                                    item: true,
                                                    xs: 1,
                                                    children: [
                                                        sortable && /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(ButtonTooltip, {
                                                                    title: "Up",
                                                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                                                        disabled: disabled || i <= 0,
                                                                        onClick: function() {
                                                                            return fields.move(i, i - 1);
                                                                        },
                                                                        children: /*#__PURE__*/ _jsx(KeyboardArrowUpIcon, {})
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(ButtonTooltip, {
                                                                    title: "Down",
                                                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                                                        disabled: disabled || fields.length === undefined || i >= fields.length - 1,
                                                                        onClick: function() {
                                                                            return fields.move(i, i + 1);
                                                                        },
                                                                        children: /*#__PURE__*/ _jsx(KeyboardArrowDownIcon, {})
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx(ButtonTooltip, {
                                                            title: "Delete Field",
                                                            children: /*#__PURE__*/ _jsx(IconButton, {
                                                                disabled: disabled,
                                                                onClick: function() {
                                                                    return fields.remove(i);
                                                                },
                                                                "data-testid": "delete-button-".concat(i),
                                                                children: /*#__PURE__*/ _jsx(DeleteIcon, {})
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, i);
                                }),
                                /*#__PURE__*/ _jsx(Grid, {
                                    item: true,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        disabled: disabled,
                                        onClick: function() {
                                            return fields.push(fieldInitialValue);
                                        },
                                        startIcon: /*#__PURE__*/ _jsx(AddBoxIcon, {}),
                                        variant: "outlined",
                                        "data-testid": "add-button",
                                        children: addFieldText
                                    })
                                })
                            ]
                        })
                    })
                ]
            });
        }
    }));
}
